import type { ConfigService } from './mx-config-service';

export class HostUrlHelper {
	static readonly $inject = ['mx.shell.Config'];
	private readonly apiHost: string;
	private readonly imgHost: string;
	private readonly basePath: string;
	private readonly rootFolders: string[];

	constructor(readonly config: ConfigService) {
		const imgHosts = this.config.get('imgHosts');
		const restHosts = this.config.get('restHosts');
		this.apiHost = restHosts.default;
		this.imgHost = imgHosts.default;
		this.basePath = (config.get('basePath') ?? '').replace(/^\//, '').replace(/\/$/, '');
		this.rootFolders = imgHosts.rootFolder;
	}

	getHostUrls() {
		return {
			apiHost: this.apiHost,
			imgHost: this.imgHost,
			getFullImageUrl: this.getFullImageUrl.bind(this),
			basePath: this.basePath,
			productName: this.config.get('productName'),
		};
	}

	getFullImageUrl(imageUrl?: string, baseFolder = '', isBasePath = false) {
		if (!imageUrl) {
			return './assets/images/no_image1.png';
		}

		const url = imageUrl.toLowerCase();
		if (/^(https?:\/\/|.\/)/.test(url)) {
			return url;
		}

		if (isBasePath || this.rootFolders.some((folder) => url.startsWith(folder.toLowerCase())) || (this.basePath.length && url.startsWith(this.basePath.toLowerCase()))) {
			return this.imgHost + url;
		}

		if (/^api\/fileStorage/i.test(url)) {
			return `${this.apiHost}/${url}/inline`;
		}

		return this.imgHost + this.rootFolders[0] + baseFolder + url;
	}
}
